/**
 * Created by aaikepae on 6/1/17.
 */


import React from 'react';
import { setRobotsNoindex } from '../../../../utility/head';
import SEO from '../../../../utility/seo';
const s3 = window.PUBHUB_CONTENT_URL;


export default class extends React.Component {

  componentDidMount() {
    let { projectName } = this.props;
    let location = this.props.phlocation;
    if (!location) {
      location = `${s3}${projectName}/docs/`;
    }
    this.mountSDK(location, {
      projectName
    })
  }

  componentWillUpdate(nextProps, nextState) {

    if (this.props.projectName !== nextProps.projectName) {
      // from /docs/sandbox/ to /docs/jasper/ in mega menu
      doc.clear();
      let { projectName } = nextProps;
      let location = nextProps.phlocation;
      if (!location) {
        location = `${s3}${projectName}/docs/`;
      }
      doc.configURL = location + "web.json";
    }
  }

  componentWillUnmount() {
    if (this.doc) {
      this.doc.unmount();
    }
  }

  getCurrentUrl = () => {
    let _url = window.location.href;
    const doc_hash = _url.split(/#!\S+\//);
    if (doc_hash.length === 2) {
      _url = _url.slice(0, -doc_hash[1].length - 1);
    }
    return _url;
  }

  mountSDK(location, params = {}) {

    PubHub.env = CONFIG["PUBHUB_ENV"];

    const doc = PubHub.createDocPage({
      container: document.getElementById("devnet-doc"),
      config: {
        "_navTopOffset": 62
      }
    });

    doc.configURL = location + "web.json";

    window.doc = this.doc = doc;

    doc.on("configDataLoaded", (event) => {

      event.detail.data.meta.location = event.detail.data.meta.location.replace("https://pubhub.devnetcloud.com/media/", window.PUBHUB_CONTENT_URL)
      if (!event.detail.data.meta.indexed) {
        setRobotsNoindex();
      }
    });

    doc.on('configDataError', (event) => {
      this.props.setError();
    });

    doc.on("init", (event) => {
      this.props.onload.call(null, doc.store.getState(), doc);
    });

    doc.on("select", (event) => {
      const uri = event.detail;
      this.props.onchange.call(null, uri, doc);
    });

    doc.on("load", (event) => {
      const store = doc.store.getState();

      if (store.selected && store.selected["item"]) {
        let fullTitle = null;
        let fullDescription = null;
        if (store.selected.data.type === 'api') {
          const title = store.selected.data.title;
          fullTitle = `${title} - ${store.meta.name} - Cisco DevNet`;
          const description = (store.selected.data.spec || {}).description || '';
          fullDescription = title == description ? `${description}` : `${title} - ${description}`;
        } else {
          const title = SEO.parseSeoTitleTag(store.selected.data) || store.selected.item.title;
          fullTitle = ((title == store.meta.name) ? title : `${title} - ${store.meta.name}`)
            + ' - Cisco DevNet';
          const description = SEO.parseSeoDescriptionTag(store.selected.data) || store.meta.description || CONFIG["PAGE_DESCRIPTION"];
          fullDescription = `${title} - ${description}`;
        }

        setTimeout(() => {
          AnalyticsSDK.trackPageView(this.getCurrentUrl(), fullTitle, fullDescription);
        }, 1);
      }
    })

    doc.on("search", (event) => {
      const store = doc.store.getState();

      const keyword = event.detail.data.q;
      const title = `Search results for "${keyword}" - ${store.meta.name} - Cisco DevNet`;
      const description = `"${keyword}" in ${store.meta.name} - ${store.meta.description || 'Cisco DevNet'}`;

      setTimeout(() => {
        AnalyticsSDK.trackPageView(this.getCurrentUrl(), title, description);
      }, 1);
    });
  }


  render() {
    return (
      <div id="devnet-doc">Loading</div>
    )
  }
}
